<div class="app-container" trackButton>
  <header *ngIf="showHeader"
          class="ahe-ui-navbar navbar learning-dark app-header">
    <div class="header-wrapper">
      <h2 class="navbar-heading">Assess Authoring</h2>
      <aa-program-banks [selectedBank]="getSelectedBank()">
      </aa-program-banks>
      <div class="float-end">
        <aa-app-menu></aa-app-menu>
        <aa-user-profile></aa-user-profile>
      </div>
    </div>
  </header>
  <div class="toast-container position-fixed top-0 start-50 m-5 translate-middle-x">
    <lh-toast></lh-toast>
  </div>
  <router-outlet></router-outlet>
  <aa-loading-spinner></aa-loading-spinner>
</div>
